module.exports = __webpack_public_path__ + "static/media/monitors.b7fdd280.svg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Shop/assets/monitors.svg
// module id = 801
// module chunks = 20